// SHADOW NETWORK™ — UI strings (ES/EN/SK)
export const SHADOW_I18N = {
  es: {
    nav_btn: "Shadow Network",
    eyebrow: "Clasificado · Acceso Operador",
    hero_title: "SHADOW NETWORK™",
    hero_sub:
      "Red de reclutamiento institucional. No invitas amigos. Reclutas operadores.",

    profile_title: "Tu identidad operativa",
    codename_label: "Codename",
    invite_label: "Código de Invitación",
    link_label: "Enlace de Reclutamiento",
    copy: "Copiar",
    copied: "Copiado",
    share: "Compartir",
    share_via_x: "X / Twitter",
    share_via_telegram: "Telegram",
    share_via_whatsapp: "WhatsApp",
    share_via_facebook: "Facebook",
    share_via_instagram: "Instagram",

    ig_modal_title: "Compartir en Instagram",
    ig_modal_sub: "Descarga la imagen y pega el texto en tu publicación o Story.",
    ig_modal_copy: "Copiar texto",
    ig_modal_copied: "Texto copiado",
    ig_modal_download: "Descargar imagen",
    ig_modal_close: "Cerrar",

    stats_xp: "RE₿EL XP™",
    stats_reputation: "Reputación",
    stats_rank: "Rango",
    stats_active: "Operadores activos",
    stats_converted: "Conversiones",
    stats_total: "Reclutados",

    rank_progress: "Progreso de rango",
    next_rank: "Próximo rango",
    xp_to_next: "XP restante",
    max_rank: "Rango máximo alcanzado",

    unlocks_title: "Sistema de Desbloqueo Operativo",
    unlocks_sub:
      "Reclutar operadores activos desbloquea niveles de acceso clasificados.",
    locked: "Bloqueado",
    unlocked: "Desbloqueado",
    invites_needed: "operadores activos restantes",

    network_title: "Tu red reclutada",
    network_empty:
      "Aún no has reclutado operadores. Comparte tu enlace para empezar.",
    status_pending: "Pendiente",
    status_active: "Activo",
    status_converted: "Convertido",
    joined_at: "Reclutado",

    leaderboard_title: "Tabla Global de Operadores",
    leaderboard_sub:
      "Top 25 por puntuación de reputación. Actualizado en tiempo real.",
    th_rank: "#",
    th_codename: "Operador",
    th_xp: "XP",
    th_rep: "Reputación",
    th_recruits: "Reclutados",

    activity_xp: {
      lesson_complete: "Completar lección",
      mentor_message: "Mensaje al Mentor IA",
      simulator_end: "Completar simulación",
      referral_active: "Operador reclutado activo",
      referral_converted: "Conversión PRO",
    },

    cta_share_label: "Difundir red operativa",
    cta_share_default:
      "Acabo de unirme a la red SHADOW NETWORK™ de RE₿EL BTC. Operadores reales. Acceso clasificado.",

    badge_pro: "PRO",
    badge_ambassador: "AMBASSADOR",
    badge_elite: "ELITE",

    rank_RECRUIT: "RECLUTA",
    rank_OPERATOR: "OPERADOR",
    rank_SHADOW_ANALYST: "ANALISTA SOMBRA",
    rank_LIQUIDITY_HUNTER: "CAZADOR DE LIQUIDEZ",
    rank_MARKET_COMMANDER: "COMANDANTE DE MERCADO",
    rank_REBEL_ELITE: "RE₿EL ELITE",

    tab_overview: "Resumen",
    tab_network: "Red",
    tab_leaderboard: "Leaderboard",

    radar_label: "Escaneo operativo activo",
    classified_seal: "CLASIFICADO · NIVEL OPS",
    join_alert_title: "Acceso de operador no autorizado",
    join_alert_msg: "Crea tu cuenta para activar tu codename y entrar a la red.",
    join_cta: "Solicitar acceso",

    // ── Share modal ─────────────────────────────────────────
    share_kit: "Share kit",
    share_all_networks: "TODAS LAS REDES",
    share_modal_title: "Compartir publicación",
    share_modal_sub: "Descarga la imagen, copia el texto y publícalo en tu red favorita. Tu enlace personal mantiene el tracking de referidos.",
    share_open_in: "Abrir en",
    share_caption_preview: "Caption preview",
    share_instagram_manual: "Instagram · manual",
    share_instagram_title: "Instagram no permite share por URL — usa Descargar + Copiar",
    share_native_title: "REBEL · La rebelión del dinero digital",

    // ── Feed (ShadowFeed) ───────────────────────────────────
    feed_eyebrow: "◈ Operación · Briefings",
    feed_title: "Análisis de la red",
    feed_sub: "Setups compartidos por operativos PRO. Reacciona, comenta y aprende de la jerarquía.",
    feed_filter_tf_ph: "Timeframe",
    feed_filter_dir_ph: "Dirección",
    feed_clear: "Limpiar",
    feed_loading: "Cargando análisis…",
    feed_empty_title: "Aún no hay análisis publicados con esos filtros.",
    feed_empty_sub: "Sé el primero en compartir — pulsa \"Publicar análisis\".",
    feed_loadmore: "Cargar más",
    feed_loadmore_loading: "Cargando…",

    // ── Chat (ShadowChat) ───────────────────────────────────
    chat_title: "Shadow Chat",
    chat_pro_writes_all_read: "Solo PRO escribe · Todos pueden leer",
    chat_loading: "Cargando…",
    chat_first_msg: "Sé el primero en escribir 👋",
    chat_admin_label: "Admin",
    chat_input_ph: "Escribe tu análisis…",
    chat_send: "Enviar",
    chat_delete: "Borrar",
    chat_confirm_delete: "¿Borrar este mensaje?",
    chat_pro_only_writes: "Solo PRO escribe en el chat",
    chat_pro_cta: "Activar PRO →",
    chat_login_required: "Inicia sesión para participar",
    chat_login_cta: "Iniciar sesión →",
    chat_enter_send_shift_newline: "Enter envía · Shift+Enter nueva línea",
    chat_relative_now: "ahora",

    // ── Ranking page (ShadowRankingPage) ────────────────────
    ranking_back_feed: "Volver al feed",
    ranking_subtitle: "La IA evalúa cada análisis y actualiza el ranking cada 24h",
    ranking_updated_today: "Actualizado hoy",
    ranking_loading: "Cargando ranking…",
    ranking_load_failed: "No se pudo cargar el ranking",
    ranking_stat_analyses: "análisis",
    ranking_stat_traders: "traders",
    ranking_stat_score_avg: "score medio",
    ranking_stat_days_left: "días restantes",
    ranking_winner_of: "Campeón de",
    ranking_winner_badge: "Ganador",
    ranking_winner_score: "Score:",
    ranking_winner_accuracy: "Precisión:",
    ranking_winner_analyses: "Análisis:",
    ranking_winner_prize: "Premio entregado: 50% en Shadow Market™",
    ranking_empty: "Aún no hay ranking este mes. Publica tus análisis y vuelve mañana.",
    ranking_how_toggle: "¿Cómo funciona el ranking?",
    ranking_how_intro_pre: "La IA evalúa cada análisis",
    ranking_how_intro_strong: "24h después",
    ranking_how_intro_post: "de su publicación, comparando la dirección predicha con el movimiento real:",
    ranking_how_b1_strong: "Dirección correcta",
    ranking_how_b1_rest: "(LONG/SHORT/NEUTRAL): 50 puntos",
    ranking_how_b2_strong: "Precisión del análisis",
    ranking_how_b2_rest: "(niveles mencionados): 30 puntos",
    ranking_how_b3_strong: "Timeframe correcto",
    ranking_how_b3_rest: ": 20 puntos",
    ranking_how_b4_strong: "Bonus de comunidad",
    ranking_how_b4_rest: "(reacciones + comentarios): hasta +10pts",
    ranking_how_footer_pre: "Requisito mínimo para el premio:",
    ranking_how_footer_min: "3 análisis evaluados",
    ranking_how_footer_mid: "ese mes. El ganador mensual recibe",
    ranking_how_footer_prize: "50% de descuento en Shadow Market™.",
    ranking_disclaimer: "El ranking es con fines educativos y de entretenimiento. Los análisis no constituyen asesoramiento financiero.",
    ranking_admin: "Admin",
    ranking_view_analyses: "Ver análisis →",
    ranking_row_analyses: "análisis",
    ranking_row_evaluated: "evaluados",
    ranking_row_correct: "correctos",
    ranking_tier_KING: "REY/REINA DEL MERCADO",
    ranking_tier_SHADOW_MASTER: "SHADOW MASTER",
    ranking_tier_LIGHTNING: "LIGHTNING TRADER",
    ranking_tier_PRECISION: "PRECISION HUNTER",
    ranking_tier_FIRE: "ON FIRE",
    ranking_tier_DIAMOND: "DIAMOND HANDS",
    ranking_tier_STRUCTURE: "STRUCTURE READER",
    ranking_tier_LIQUIDITY: "LIQUIDITY DIVER",
    ranking_tier_RISING: "RISING REBEL",
    ranking_months: {
      "01": "ENERO", "02": "FEBRERO", "03": "MARZO", "04": "ABRIL",
      "05": "MAYO", "06": "JUNIO", "07": "JULIO", "08": "AGOSTO",
      "09": "SEPTIEMBRE", "10": "OCTUBRE", "11": "NOVIEMBRE", "12": "DICIEMBRE",
    },

    // ── Ranking widget (sidebar) ────────────────────────────
    rw_top_traders: "⚡ Top Traders del Mes",
    rw_calculating: "Calculando…",
    rw_empty: "Aún no hay análisis evaluados este mes.",
    rw_see_full: "Ver ranking completo →",
    rw_days_unit: "días",
    rw_until_month_end: "para fin de mes",
    rw_prize: "Premio",
    rw_prize_value: "50% Shadow Mkt",

    // ── Analysis card ──────────────────────────────────────
    ac_zoom_image: "Ampliar",
    ac_zoom_aria: "Ampliar imagen",
    ac_ago_prefix: "hace",
    ac_ago_now: "ahora",
    ac_eval_pending: "Esperando 24h para evaluar",
    ac_delete: "Eliminar",
    ac_delete_admin: "Eliminar (Admin)",
    ac_admin_label: "Admin",

    // ── Analysis comments (inline) ─────────────────────────
    acm_header: "Comentarios",
    acm_loading: "Cargando…",
    acm_empty: "Sé el primero en comentar.",
    acm_admin_badge: "Shadow Admin",
    acm_delete_aria: "Eliminar comentario",
    acm_placeholder: "Escribe un comentario…",
    acm_submit: "Comentar",
    acm_max_chars: "Máximo 280 caracteres",
    acm_error_generic: "Error al comentar",
    acm_login: "Inicia sesión",
    acm_login_suffix: " para comentar · ",
    acm_register: "Crear cuenta gratis",
    acm_ago_prefix: "hace",
    acm_ago_now: "ahora",

    // ── Publish analysis modal ─────────────────────────────
    pam_button: "Publicar análisis",
    pam_field_title: "Título",
    pam_field_title_ph: "Ej: BTC estructura alcista en 4H — Posible entrada",
    pam_field_analysis: "Análisis",
    pam_field_analysis_ph: "Describe tu análisis con todo el detalle que necesites: estructura de mercado, niveles clave, order blocks, zonas de liquidez, sesgo macro, invalidación del setup, gestión del trade...",
    pam_field_ticker_ph: "BTC/USDT",
    pam_field_direction: "Dirección",
    pam_submit: "Publicar análisis →",
    pam_processing_video: "Procesando vídeo…",
    pam_publishing: "Publicando…",
    pam_err_video_type: "Vídeo: MP4, MOV o WebM.",
    pam_err_video_size: "Vídeo máximo 100MB.",
    pam_err_file_type: "Solo JPG, PNG, WebP — o vídeo MP4/MOV/WebM.",
    pam_err_image_size: "Imagen máximo 5MB.",
    pam_err_select_file: "Selecciona una imagen o vídeo.",
    pam_err_title_min: "Título mínimo 3 caracteres.",
    pam_err_title_max: "Título máximo 80 caracteres.",
    pam_err_desc_min: "Descripción mínimo 50 caracteres.",
    pam_err_desc_max: "Descripción máximo 5000 caracteres.",
    pam_cancel: "Cancelar",
    pam_published: "Publicado",
    pam_video_hint: "⚡ El vídeo se procesará automáticamente y se recortará a 90s.",
    pam_label_ticker: "Ticker",
    pam_label_timeframe: "Timeframe",
    pam_chars_5000: "caracteres",
    pam_pro_gate_title: "Publicar es para PRO",
    pam_pro_gate_body: "Activa RE₿EL PRO para compartir tus análisis con la Shadow Network. Todos pueden ver y reaccionar, pero solo PRO publica.",
    pam_pro_gate_cta: "Activar PRO · €39.90",
    pam_eyebrow: "◈ Shadow Network · Publicación",
    pam_modal_title: "Comparte tu análisis",
    pam_modal_sub: "Solo los operativos PRO pueden publicar. Todos pueden ver.",
    pam_dropzone_title: "Arrastra tu análisis aquí",
    pam_dropzone_sub: "o haz click · imagen 5MB · vídeo 100MB · máx 90s",
    pam_video_badge: "▶ VÍDEO · MÁX 90s",

    // ── Share post ─────────────────────────────────────────
    sp_btn: "Compartir",
    sp_aria: "Compartir análisis",
    sp_err_image: "No se pudo generar la imagen. Inténtalo de nuevo.",
  },
  en: {
    nav_btn: "Shadow Network",
    eyebrow: "Classified · Operator Access",
    hero_title: "SHADOW NETWORK™",
    hero_sub:
      "Institutional recruitment network. You don't invite friends. You recruit operators.",

    profile_title: "Your operative identity",
    codename_label: "Codename",
    invite_label: "Invite Code",
    link_label: "Recruitment Link",
    copy: "Copy",
    copied: "Copied",
    share: "Share",
    share_via_x: "X / Twitter",
    share_via_telegram: "Telegram",
    share_via_whatsapp: "WhatsApp",
    share_via_facebook: "Facebook",
    share_via_instagram: "Instagram",

    ig_modal_title: "Share on Instagram",
    ig_modal_sub: "Download the image and paste the text into your post or Story.",
    ig_modal_copy: "Copy text",
    ig_modal_copied: "Text copied",
    ig_modal_download: "Download image",
    ig_modal_close: "Close",

    stats_xp: "RE₿EL XP™",
    stats_reputation: "Reputation",
    stats_rank: "Rank",
    stats_active: "Active operators",
    stats_converted: "Conversions",
    stats_total: "Recruited",

    rank_progress: "Rank progression",
    next_rank: "Next rank",
    xp_to_next: "XP remaining",
    max_rank: "Maximum rank reached",

    unlocks_title: "Operative Unlock System",
    unlocks_sub:
      "Recruit active operators to unlock classified access tiers.",
    locked: "Locked",
    unlocked: "Unlocked",
    invites_needed: "active operators remaining",

    network_title: "Your recruited network",
    network_empty:
      "No operators recruited yet. Share your link to begin.",
    status_pending: "Pending",
    status_active: "Active",
    status_converted: "Converted",
    joined_at: "Recruited",

    leaderboard_title: "Global Operator Leaderboard",
    leaderboard_sub: "Top 25 by reputation score. Updated in real time.",
    th_rank: "#",
    th_codename: "Operator",
    th_xp: "XP",
    th_rep: "Reputation",
    th_recruits: "Recruits",

    activity_xp: {
      lesson_complete: "Complete a lesson",
      mentor_message: "AI Mentor message",
      simulator_end: "Complete a simulation",
      referral_active: "Active recruited operator",
      referral_converted: "PRO conversion",
    },

    cta_share_label: "Broadcast operative network",
    cta_share_default:
      "Just joined the RE₿EL BTC SHADOW NETWORK™. Real operators. Classified access.",

    badge_pro: "PRO",
    badge_ambassador: "AMBASSADOR",
    badge_elite: "ELITE",

    rank_RECRUIT: "RECRUIT",
    rank_OPERATOR: "OPERATOR",
    rank_SHADOW_ANALYST: "SHADOW ANALYST",
    rank_LIQUIDITY_HUNTER: "LIQUIDITY HUNTER",
    rank_MARKET_COMMANDER: "MARKET COMMANDER",
    rank_REBEL_ELITE: "RE₿EL ELITE",

    tab_overview: "Overview",
    tab_network: "Network",
    tab_leaderboard: "Leaderboard",

    radar_label: "Operative scan active",
    classified_seal: "CLASSIFIED · OPS LEVEL",
    join_alert_title: "Unauthorized operator access",
    join_alert_msg: "Create your account to activate your codename and enter the network.",
    join_cta: "Request access",

    // ── Share modal ─────────────────────────────────────────
    share_kit: "Share kit",
    share_all_networks: "ALL NETWORKS",
    share_modal_title: "Share post",
    share_modal_sub: "Download the image, copy the text and post it on your favourite network. Your personal link keeps the referral tracking.",
    share_open_in: "Open in",
    share_caption_preview: "Caption preview",
    share_instagram_manual: "Instagram · manual",
    share_instagram_title: "Instagram doesn't allow URL share — use Download + Copy",
    share_native_title: "REBEL · The digital money rebellion",

    // ── Feed (ShadowFeed) ───────────────────────────────────
    feed_eyebrow: "◈ Operation · Briefings",
    feed_title: "Network analyses",
    feed_sub: "Setups shared by PRO operatives. React, comment and learn from the hierarchy.",
    feed_filter_tf_ph: "Timeframe",
    feed_filter_dir_ph: "Direction",
    feed_clear: "Clear",
    feed_loading: "Loading analyses…",
    feed_empty_title: "No analyses published with those filters yet.",
    feed_empty_sub: "Be the first to share — tap \"Publish analysis\".",
    feed_loadmore: "Load more",
    feed_loadmore_loading: "Loading…",

    // ── Chat (ShadowChat) ───────────────────────────────────
    chat_title: "Shadow Chat",
    chat_pro_writes_all_read: "Only PRO writes · Everyone can read",
    chat_loading: "Loading…",
    chat_first_msg: "Be the first to write 👋",
    chat_admin_label: "Admin",
    chat_input_ph: "Write your analysis…",
    chat_send: "Send",
    chat_delete: "Delete",
    chat_confirm_delete: "Delete this message?",
    chat_pro_only_writes: "Only PRO writes in the chat",
    chat_pro_cta: "Activate PRO →",
    chat_login_required: "Sign in to participate",
    chat_login_cta: "Sign in →",
    chat_enter_send_shift_newline: "Enter sends · Shift+Enter new line",
    chat_relative_now: "now",

    // ── Ranking page (ShadowRankingPage) ────────────────────
    ranking_back_feed: "Back to feed",
    ranking_subtitle: "AI evaluates every analysis and updates the ranking every 24h",
    ranking_updated_today: "Updated today",
    ranking_loading: "Loading ranking…",
    ranking_load_failed: "Could not load ranking",
    ranking_stat_analyses: "analyses",
    ranking_stat_traders: "traders",
    ranking_stat_score_avg: "average score",
    ranking_stat_days_left: "days left",
    ranking_winner_of: "Champion of",
    ranking_winner_badge: "Winner",
    ranking_winner_score: "Score:",
    ranking_winner_accuracy: "Accuracy:",
    ranking_winner_analyses: "Analyses:",
    ranking_winner_prize: "Prize delivered: 50% off Shadow Market™",
    ranking_empty: "No ranking this month yet. Publish your analyses and come back tomorrow.",
    ranking_how_toggle: "How does the ranking work?",
    ranking_how_intro_pre: "The AI evaluates every analysis",
    ranking_how_intro_strong: "24h after",
    ranking_how_intro_post: "publication, comparing predicted direction with the real move:",
    ranking_how_b1_strong: "Correct direction",
    ranking_how_b1_rest: "(LONG/SHORT/NEUTRAL): 50 points",
    ranking_how_b2_strong: "Analysis accuracy",
    ranking_how_b2_rest: "(levels mentioned): 30 points",
    ranking_how_b3_strong: "Correct timeframe",
    ranking_how_b3_rest: ": 20 points",
    ranking_how_b4_strong: "Community bonus",
    ranking_how_b4_rest: "(reactions + comments): up to +10pts",
    ranking_how_footer_pre: "Minimum prize requirement:",
    ranking_how_footer_min: "3 evaluated analyses",
    ranking_how_footer_mid: "that month. The monthly winner receives",
    ranking_how_footer_prize: "50% off Shadow Market™.",
    ranking_disclaimer: "The ranking is for educational and entertainment purposes only. Analyses do not constitute financial advice.",
    ranking_admin: "Admin",
    ranking_view_analyses: "View analyses →",
    ranking_row_analyses: "analyses",
    ranking_row_evaluated: "evaluated",
    ranking_row_correct: "correct",
    ranking_tier_KING: "KING/QUEEN OF THE MARKET",
    ranking_tier_SHADOW_MASTER: "SHADOW MASTER",
    ranking_tier_LIGHTNING: "LIGHTNING TRADER",
    ranking_tier_PRECISION: "PRECISION HUNTER",
    ranking_tier_FIRE: "ON FIRE",
    ranking_tier_DIAMOND: "DIAMOND HANDS",
    ranking_tier_STRUCTURE: "STRUCTURE READER",
    ranking_tier_LIQUIDITY: "LIQUIDITY DIVER",
    ranking_tier_RISING: "RISING REBEL",
    ranking_months: {
      "01": "JANUARY", "02": "FEBRUARY", "03": "MARCH", "04": "APRIL",
      "05": "MAY", "06": "JUNE", "07": "JULY", "08": "AUGUST",
      "09": "SEPTEMBER", "10": "OCTOBER", "11": "NOVEMBER", "12": "DECEMBER",
    },

    // ── Ranking widget (sidebar) ────────────────────────────
    rw_top_traders: "⚡ Top Traders of the Month",
    rw_calculating: "Calculating…",
    rw_empty: "No evaluated analyses this month yet.",
    rw_see_full: "See full ranking →",
    rw_days_unit: "days",
    rw_until_month_end: "until end of month",
    rw_prize: "Prize",
    rw_prize_value: "50% Shadow Mkt",

    // ── Analysis card ──────────────────────────────────────
    ac_zoom_image: "Zoom",
    ac_zoom_aria: "Zoom image",
    ac_ago_prefix: "",
    ac_ago_now: "now",
    ac_eval_pending: "Waiting 24h to evaluate",
    ac_delete: "Delete",
    ac_delete_admin: "Delete (Admin)",
    ac_admin_label: "Admin",

    // ── Analysis comments (inline) ─────────────────────────
    acm_header: "Comments",
    acm_loading: "Loading…",
    acm_empty: "Be the first to comment.",
    acm_admin_badge: "Shadow Admin",
    acm_delete_aria: "Delete comment",
    acm_placeholder: "Write a comment…",
    acm_submit: "Comment",
    acm_max_chars: "Maximum 280 characters",
    acm_error_generic: "Failed to comment",
    acm_login: "Sign in",
    acm_login_suffix: " to comment · ",
    acm_register: "Create free account",
    acm_ago_prefix: "",
    acm_ago_now: "now",

    // ── Publish analysis modal ─────────────────────────────
    pam_button: "Publish analysis",
    pam_field_title: "Title",
    pam_field_title_ph: "E.g. BTC bullish 4H structure — possible entry",
    pam_field_analysis: "Analysis",
    pam_field_analysis_ph: "Describe your analysis with all the detail you need: market structure, key levels, order blocks, liquidity zones, macro bias, setup invalidation, trade management...",
    pam_field_ticker_ph: "BTC/USDT",
    pam_field_direction: "Direction",
    pam_submit: "Publish analysis →",
    pam_processing_video: "Processing video…",
    pam_publishing: "Publishing…",
    pam_err_video_type: "Video: MP4, MOV or WebM.",
    pam_err_video_size: "Video max 100MB.",
    pam_err_file_type: "Only JPG, PNG, WebP — or video MP4/MOV/WebM.",
    pam_err_image_size: "Image max 5MB.",
    pam_err_select_file: "Select an image or video.",
    pam_err_title_min: "Title min 3 characters.",
    pam_err_title_max: "Title max 80 characters.",
    pam_err_desc_min: "Description min 50 characters.",
    pam_err_desc_max: "Description max 5000 characters.",
    pam_cancel: "Cancel",
    pam_published: "Published",
    pam_video_hint: "⚡ The video will be processed automatically and trimmed to 90s.",
    pam_label_ticker: "Ticker",
    pam_label_timeframe: "Timeframe",
    pam_chars_5000: "characters",
    pam_pro_gate_title: "Publishing is for PRO",
    pam_pro_gate_body: "Activate RE₿EL PRO to share your analyses with the Shadow Network. Everyone can view and react, but only PRO can publish.",
    pam_pro_gate_cta: "Activate PRO · €39.90",
    pam_eyebrow: "◈ Shadow Network · Publication",
    pam_modal_title: "Share your analysis",
    pam_modal_sub: "Only PRO operatives can publish. Everyone can view.",
    pam_dropzone_title: "Drag your analysis here",
    pam_dropzone_sub: "or click · image 5MB · video 100MB · max 90s",
    pam_video_badge: "▶ VIDEO · MAX 90s",

    // ── Share post ─────────────────────────────────────────
    sp_btn: "Share",
    sp_aria: "Share analysis",
    sp_err_image: "Could not generate the image. Please try again.",
  },
  sk: {
    nav_btn: "Shadow Network",
    eyebrow: "Tajné · Prístup operátora",
    hero_title: "SHADOW NETWORK™",
    hero_sub:
      "Inštitucionálna náborová sieť. Neprivádzaš priateľov. Náboruješ operátorov.",

    profile_title: "Tvoja operatívna identita",
    codename_label: "Codename",
    invite_label: "Pozvánkový kód",
    link_label: "Náborový odkaz",
    copy: "Kopírovať",
    copied: "Skopírované",
    share: "Zdieľať",
    share_via_x: "X / Twitter",
    share_via_telegram: "Telegram",
    share_via_whatsapp: "WhatsApp",
    share_via_facebook: "Facebook",
    share_via_instagram: "Instagram",

    ig_modal_title: "Zdieľať na Instagrame",
    ig_modal_sub: "Stiahni obrázok a vlož text do svojho príspevku alebo Story.",
    ig_modal_copy: "Skopírovať text",
    ig_modal_copied: "Text skopírovaný",
    ig_modal_download: "Stiahnuť obrázok",
    ig_modal_close: "Zavrieť",

    stats_xp: "RE₿EL XP™",
    stats_reputation: "Reputácia",
    stats_rank: "Hodnosť",
    stats_active: "Aktívni operátori",
    stats_converted: "Konverzie",
    stats_total: "Naverbovaní",

    rank_progress: "Postup hodnosti",
    next_rank: "Ďalšia hodnosť",
    xp_to_next: "Zostávajúce XP",
    max_rank: "Maximálna hodnosť dosiahnutá",

    unlocks_title: "Systém Operatívneho Odomykania",
    unlocks_sub:
      "Naverbuj aktívnych operátorov, aby si odomkol tajné úrovne prístupu.",
    locked: "Zamknuté",
    unlocked: "Odomknuté",
    invites_needed: "aktívnych operátorov zostáva",

    network_title: "Tvoja naverbovaná sieť",
    network_empty: "Zatiaľ žiadni operátori. Zdieľaj svoj odkaz a začni.",
    status_pending: "Čaká",
    status_active: "Aktívny",
    status_converted: "Konvertovaný",
    joined_at: "Naverbovaný",

    leaderboard_title: "Globálny rebríček operátorov",
    leaderboard_sub: "Top 25 podľa reputácie. Aktualizované v reálnom čase.",
    th_rank: "#",
    th_codename: "Operátor",
    th_xp: "XP",
    th_rep: "Reputácia",
    th_recruits: "Verbovania",

    activity_xp: {
      lesson_complete: "Dokončenie lekcie",
      mentor_message: "Správa AI Mentorovi",
      simulator_end: "Dokončenie simulácie",
      referral_active: "Aktívny naverbovaný operátor",
      referral_converted: "PRO konverzia",
    },

    cta_share_label: "Šíriť operatívnu sieť",
    cta_share_default:
      "Práve som sa pripojil k RE₿EL BTC SHADOW NETWORK™. Skutoční operátori. Tajný prístup.",

    badge_pro: "PRO",
    badge_ambassador: "AMBASSADOR",
    badge_elite: "ELITE",

    rank_RECRUIT: "REGRÚT",
    rank_OPERATOR: "OPERÁTOR",
    rank_SHADOW_ANALYST: "TIEŇOVÝ ANALYTIK",
    rank_LIQUIDITY_HUNTER: "LOVEC LIKVIDITY",
    rank_MARKET_COMMANDER: "VELITEĽ TRHU",
    rank_REBEL_ELITE: "RE₿EL ELITE",

    tab_overview: "Prehľad",
    tab_network: "Sieť",
    tab_leaderboard: "Rebríček",

    radar_label: "Operatívne skenovanie aktívne",
    classified_seal: "TAJNÉ · ÚROVEŇ OPS",
    join_alert_title: "Neoprávnený prístup operátora",
    join_alert_msg: "Vytvor si účet, aby si aktivoval svoj codename a vstúpil do siete.",
    join_cta: "Požiadať o prístup",

    // ── Share modal ─────────────────────────────────────────
    share_kit: "Share kit",
    share_all_networks: "VŠETKY SIETE",
    share_modal_title: "Zdieľať príspevok",
    share_modal_sub: "Stiahni obrázok, skopíruj text a uverejni ho vo svojej obľúbenej sieti. Tvoj osobný odkaz uchová tracking odporúčaní.",
    share_open_in: "Otvoriť v",
    share_caption_preview: "Náhľad popisu",
    share_instagram_manual: "Instagram · manuálne",
    share_instagram_title: "Instagram neumožňuje zdieľanie cez URL — použi Stiahnuť + Skopírovať",
    share_native_title: "REBEL · Vzbura digitálnych peňazí",

    // ── Feed (ShadowFeed) ───────────────────────────────────
    feed_eyebrow: "◈ Operácia · Briefingy",
    feed_title: "Analýzy siete",
    feed_sub: "Setupy zdieľané PRO operátormi. Reaguj, komentuj a uč sa od hierarchie.",
    feed_filter_tf_ph: "Timeframe",
    feed_filter_dir_ph: "Smer",
    feed_clear: "Vyčistiť",
    feed_loading: "Načítavajú sa analýzy…",
    feed_empty_title: "Zatiaľ žiadne analýzy s týmito filtrami.",
    feed_empty_sub: "Buď prvý — klikni „Publikovať analýzu\".",
    feed_loadmore: "Načítať viac",
    feed_loadmore_loading: "Načítavanie…",

    // ── Chat (ShadowChat) ───────────────────────────────────
    chat_title: "Shadow Chat",
    chat_pro_writes_all_read: "Iba PRO píše · Všetci môžu čítať",
    chat_loading: "Načítavanie…",
    chat_first_msg: "Buď prvý, kto napíše 👋",
    chat_admin_label: "Admin",
    chat_input_ph: "Napíš svoju analýzu…",
    chat_send: "Odoslať",
    chat_delete: "Vymazať",
    chat_confirm_delete: "Vymazať túto správu?",
    chat_pro_only_writes: "Iba PRO môže písať do chatu",
    chat_pro_cta: "Aktivovať PRO →",
    chat_login_required: "Prihlás sa, aby si sa mohol zapojiť",
    chat_login_cta: "Prihlásiť sa →",
    chat_enter_send_shift_newline: "Enter odošle · Shift+Enter nový riadok",
    chat_relative_now: "teraz",

    // ── Ranking page (ShadowRankingPage) ────────────────────
    ranking_back_feed: "Späť na feed",
    ranking_subtitle: "AI hodnotí každú analýzu a aktualizuje rebríček každých 24h",
    ranking_updated_today: "Aktualizované dnes",
    ranking_loading: "Načítavanie rebríčka…",
    ranking_load_failed: "Rebríček sa nepodarilo načítať",
    ranking_stat_analyses: "analýz",
    ranking_stat_traders: "obchodníkov",
    ranking_stat_score_avg: "priemerné skóre",
    ranking_stat_days_left: "zostáva dní",
    ranking_winner_of: "Šampión",
    ranking_winner_badge: "Víťaz",
    ranking_winner_score: "Skóre:",
    ranking_winner_accuracy: "Presnosť:",
    ranking_winner_analyses: "Analýzy:",
    ranking_winner_prize: "Cena odovzdaná: 50% zľava v Shadow Market™",
    ranking_empty: "Tento mesiac zatiaľ žiadny rebríček. Publikuj svoje analýzy a vráť sa zajtra.",
    ranking_how_toggle: "Ako funguje rebríček?",
    ranking_how_intro_pre: "AI vyhodnotí každú analýzu",
    ranking_how_intro_strong: "24h po",
    ranking_how_intro_post: "publikácii a porovná predikovaný smer so skutočným pohybom:",
    ranking_how_b1_strong: "Správny smer",
    ranking_how_b1_rest: "(LONG/SHORT/NEUTRAL): 50 bodov",
    ranking_how_b2_strong: "Presnosť analýzy",
    ranking_how_b2_rest: "(uvedené úrovne): 30 bodov",
    ranking_how_b3_strong: "Správny timeframe",
    ranking_how_b3_rest: ": 20 bodov",
    ranking_how_b4_strong: "Komunitný bonus",
    ranking_how_b4_rest: "(reakcie + komentáre): až +10 bodov",
    ranking_how_footer_pre: "Minimálna podmienka pre cenu:",
    ranking_how_footer_min: "3 vyhodnotené analýzy",
    ranking_how_footer_mid: "v danom mesiaci. Mesačný víťaz získa",
    ranking_how_footer_prize: "50% zľavu v Shadow Market™.",
    ranking_disclaimer: "Rebríček slúži na vzdelávacie a zábavné účely. Analýzy nepredstavujú finančné poradenstvo.",
    ranking_admin: "Admin",
    ranking_view_analyses: "Zobraziť analýzy →",
    ranking_row_analyses: "analýz",
    ranking_row_evaluated: "vyhodnotených",
    ranking_row_correct: "správnych",
    ranking_tier_KING: "KRÁĽ/KRÁĽOVNÁ TRHU",
    ranking_tier_SHADOW_MASTER: "SHADOW MASTER",
    ranking_tier_LIGHTNING: "LIGHTNING TRADER",
    ranking_tier_PRECISION: "PRECISION HUNTER",
    ranking_tier_FIRE: "ON FIRE",
    ranking_tier_DIAMOND: "DIAMOND HANDS",
    ranking_tier_STRUCTURE: "STRUCTURE READER",
    ranking_tier_LIQUIDITY: "LIQUIDITY DIVER",
    ranking_tier_RISING: "RISING REBEL",
    ranking_months: {
      "01": "JANUÁR", "02": "FEBRUÁR", "03": "MAREC", "04": "APRÍL",
      "05": "MÁJ", "06": "JÚN", "07": "JÚL", "08": "AUGUST",
      "09": "SEPTEMBER", "10": "OKTÓBER", "11": "NOVEMBER", "12": "DECEMBER",
    },

    // ── Ranking widget (sidebar) ────────────────────────────
    rw_top_traders: "⚡ Top obchodníci mesiaca",
    rw_calculating: "Počítam…",
    rw_empty: "Tento mesiac zatiaľ žiadne vyhodnotené analýzy.",
    rw_see_full: "Zobraziť celý rebríček →",
    rw_days_unit: "dní",
    rw_until_month_end: "do konca mesiaca",
    rw_prize: "Cena",
    rw_prize_value: "50% Shadow Mkt",

    // ── Analysis card ──────────────────────────────────────
    ac_zoom_image: "Zväčšiť",
    ac_zoom_aria: "Zväčšiť obrázok",
    ac_ago_prefix: "pred",
    ac_ago_now: "teraz",
    ac_eval_pending: "Čaká 24h na vyhodnotenie",
    ac_delete: "Vymazať",
    ac_delete_admin: "Vymazať (Admin)",
    ac_admin_label: "Admin",

    // ── Analysis comments (inline) ─────────────────────────
    acm_header: "Komentáre",
    acm_loading: "Načítavanie…",
    acm_empty: "Buď prvý, kto napíše komentár.",
    acm_admin_badge: "Shadow Admin",
    acm_delete_aria: "Vymazať komentár",
    acm_placeholder: "Napíš komentár…",
    acm_submit: "Komentovať",
    acm_max_chars: "Maximálne 280 znakov",
    acm_error_generic: "Chyba pri komentovaní",
    acm_login: "Prihlás sa",
    acm_login_suffix: " ak chceš komentovať · ",
    acm_register: "Vytvoriť bezplatný účet",
    acm_ago_prefix: "pred",
    acm_ago_now: "teraz",

    // ── Publish analysis modal ─────────────────────────────
    pam_button: "Publikovať analýzu",
    pam_field_title: "Názov",
    pam_field_title_ph: "Napr.: BTC bullish 4H štruktúra — možný vstup",
    pam_field_analysis: "Analýza",
    pam_field_analysis_ph: "Popíš svoju analýzu s plnými detailmi: trhová štruktúra, kľúčové úrovne, order blocky, zóny likvidity, makro bias, invalidácia setupu, riadenie tradu...",
    pam_field_ticker_ph: "BTC/USDT",
    pam_field_direction: "Smer",
    pam_submit: "Publikovať analýzu →",
    pam_processing_video: "Spracovanie videa…",
    pam_publishing: "Publikuje sa…",
    pam_err_video_type: "Video: MP4, MOV alebo WebM.",
    pam_err_video_size: "Video maximum 100MB.",
    pam_err_file_type: "Iba JPG, PNG, WebP — alebo video MP4/MOV/WebM.",
    pam_err_image_size: "Obrázok maximum 5MB.",
    pam_err_select_file: "Vyber obrázok alebo video.",
    pam_err_title_min: "Názov minimum 3 znaky.",
    pam_err_title_max: "Názov maximum 80 znakov.",
    pam_err_desc_min: "Popis minimum 50 znakov.",
    pam_err_desc_max: "Popis maximum 5000 znakov.",
    pam_cancel: "Zrušiť",
    pam_published: "Publikované",
    pam_video_hint: "⚡ Video sa automaticky spracuje a oreže na 90 s.",
    pam_label_ticker: "Ticker",
    pam_label_timeframe: "Timeframe",
    pam_chars_5000: "znakov",
    pam_pro_gate_title: "Publikovať môže iba PRO",
    pam_pro_gate_body: "Aktivuj RE₿EL PRO a zdieľaj svoje analýzy v Shadow Network. Všetci môžu vidieť a reagovať, ale publikovať môže iba PRO.",
    pam_pro_gate_cta: "Aktivovať PRO · €39.90",
    pam_eyebrow: "◈ Shadow Network · Publikácia",
    pam_modal_title: "Zdieľaj svoju analýzu",
    pam_modal_sub: "Publikovať môžu iba PRO operátori. Všetci si môžu pozrieť.",
    pam_dropzone_title: "Pretiahni sem svoju analýzu",
    pam_dropzone_sub: "alebo klikni · obrázok 5MB · video 100MB · max 90 s",
    pam_video_badge: "▶ VIDEO · MAX 90 s",

    // ── Share post ─────────────────────────────────────────
    sp_btn: "Zdieľať",
    sp_aria: "Zdieľať analýzu",
    sp_err_image: "Obrázok sa nepodarilo vygenerovať. Skús to znova.",
  },
  "zh-CN": {
    nav_btn: "Shadow Network",
    eyebrow: "机密 · 交易员通道",
    hero_title: "SHADOW NETWORK™",
    hero_sub: "机构级招募网络。你不是邀请朋友，而是招募交易员。",
    profile_title: "你的作战身份",
    codename_label: "代号",
    invite_label: "邀请码",
    link_label: "招募链接",
    copy: "复制",
    copied: "已复制",
    share: "分享",
    share_via_x: "X / Twitter",
    share_via_telegram: "Telegram",
    share_via_whatsapp: "WhatsApp",
    share_via_facebook: "Facebook",
    share_via_instagram: "Instagram",
    ig_modal_title: "在Instagram上分享",
    ig_modal_sub: "下载图片并将文案粘贴到你的帖子或Story中。",
    ig_modal_copy: "复制文案",
    ig_modal_copied: "文案已复制",
    ig_modal_download: "下载图片",
    ig_modal_close: "关闭",
    stats_xp: "RE₿EL XP™",
    stats_reputation: "声望",
    stats_rank: "等级",
    stats_active: "活跃交易员",
    stats_converted: "转化数",
    stats_total: "已招募",
    rank_progress: "等级进度",
    next_rank: "下一等级",
    xp_to_next: "剩余XP",
    max_rank: "已达到最高等级",
    unlocks_title: "作战解锁系统",
    unlocks_sub: "招募活跃交易员可解锁机密访问级别。",
    locked: "锁定",
    unlocked: "已解锁",
    invites_needed: "还需活跃交易员",
    network_title: "你的招募网络",
    network_empty: "你还未招募任何交易员。分享你的链接开始招募。",
    status_pending: "待定",
    status_active: "活跃",
    status_converted: "已转化",
    joined_at: "招募日期",
    leaderboard_title: "全球交易员排行榜",
    leaderboard_sub: "按声望分数排名前25。实时更新。",
    th_rank: "#",
    th_codename: "交易员",
    th_xp: "XP",
    th_rep: "声望",
    th_recruits: "招募数",
    activity_xp: {
      lesson_complete: "完成课程",
      mentor_message: "向AI导师发送消息",
      simulator_end: "完成模拟",
      referral_active: "招募活跃交易员",
      referral_converted: "PRO转化",
    },
    cta_share_label: "扩展作战网络",
    cta_share_default: "我刚加入了RE₿EL BTC的SHADOW NETWORK™。真实交易员。机密访问权限。",
    badge_pro: "PRO",
    badge_ambassador: "AMBASSADOR",
    badge_elite: "ELITE",
    rank_RECRUIT: "新兵",
    rank_OPERATOR: "作战员",
    rank_SHADOW_ANALYST: "影子分析师",
    rank_LIQUIDITY_HUNTER: "流动性猎手",
    rank_MARKET_COMMANDER: "市场指挥官",
    rank_REBEL_ELITE: "RE₿EL ELITE",
    tab_overview: "概览",
    tab_network: "网络",
    tab_leaderboard: "排行榜",
    radar_label: "作战扫描进行中",
    classified_seal: "机密 · 作战级别",
    join_alert_title: "未授权的交易员访问",
    join_alert_msg: "创建账户以激活你的代号并加入网络。",
    join_cta: "申请访问",
    share_kit: "分享工具包",
    share_all_networks: "所有网络",
    share_modal_title: "分享帖子",
    share_modal_sub: "下载图片，复制文案并发布到你喜欢的网络。你的个人链接会保留推荐追踪。",
    share_open_in: "在此打开",
    share_caption_preview: "文案预览",
    share_instagram_manual: "Instagram · 手动",
    share_instagram_title: "Instagram不支持URL分享 — 请使用下载+复制",
    share_native_title: "REBEL · 数字货币的革命",
    feed_eyebrow: "◈ 作战 · 简报",
    feed_title: "网络分析",
    feed_sub: "PRO交易员分享的设置。点赞、评论并向高手学习。",
    feed_filter_tf_ph: "时间周期",
    feed_filter_dir_ph: "方向",
    feed_clear: "清除",
    feed_loading: "加载分析中…",
    feed_empty_title: "该筛选条件下还没有发布的分析。",
    feed_empty_sub: "成为第一个分享的人 — 点击\"发布分析\"。",
    feed_loadmore: "加载更多",
    feed_loadmore_loading: "加载中…",
    chat_title: "Shadow Chat",
    chat_pro_writes_all_read: "仅PRO可写 · 所有人可读",
    chat_loading: "加载中…",
    chat_first_msg: "成为第一个发言的人 👋",
    chat_admin_label: "管理员",
    chat_input_ph: "写下你的分析…",
    chat_send: "发送",
    chat_delete: "删除",
    chat_confirm_delete: "删除此消息？",
    chat_pro_only_writes: "仅PRO可在聊天中发言",
    chat_pro_cta: "激活PRO →",
    chat_login_required: "登录以参与",
    chat_login_cta: "登录 →",
    chat_enter_send_shift_newline: "Enter发送 · Shift+Enter换行",
    chat_relative_now: "刚刚",
    ranking_back_feed: "返回动态",
    ranking_subtitle: "AI评估每个分析并每24小时更新排名",
    ranking_updated_today: "今日已更新",
    ranking_loading: "加载排名中…",
    ranking_load_failed: "无法加载排名",
    ranking_stat_analyses: "分析",
    ranking_stat_traders: "交易员",
    ranking_stat_score_avg: "平均分数",
    ranking_stat_days_left: "剩余天数",
    ranking_winner_of: "冠军",
    ranking_winner_badge: "获胜者",
    ranking_winner_score: "分数：",
    ranking_winner_accuracy: "准确率：",
    ranking_winner_analyses: "分析：",
    ranking_winner_prize: "奖励已发放：Shadow Market™ 50%折扣",
    ranking_empty: "本月还没有排名。发布你的分析并明天再来查看。",
    ranking_how_toggle: "排名如何运作？",
    ranking_how_intro_pre: "AI在每个分析发布后",
    ranking_how_intro_strong: "24小时",
    ranking_how_intro_post: "进行评估，对比预测方向与实际走势：",
    ranking_how_b1_strong: "方向正确",
    ranking_how_b1_rest: "（LONG/SHORT/NEUTRAL）：50分",
    ranking_how_b2_strong: "分析精确度",
    ranking_how_b2_rest: "（提及的点位）：30分",
    ranking_how_b3_strong: "时间周期正确",
    ranking_how_b3_rest: "：20分",
    ranking_how_b4_strong: "社区加成",
    ranking_how_b4_rest: "（点赞+评论）：最多+10分",
    ranking_how_footer_pre: "获奖最低要求：",
    ranking_how_footer_min: "3个已评估分析",
    ranking_how_footer_mid: "在该月。月度获胜者获得",
    ranking_how_footer_prize: "Shadow Market™ 50%折扣。",
    ranking_disclaimer: "排名仅用于教育和娱乐目的。分析不构成财务建议。",
    ranking_admin: "管理员",
    ranking_view_analyses: "查看分析 →",
    ranking_row_analyses: "分析",
    ranking_row_evaluated: "已评估",
    ranking_row_correct: "正确",
    ranking_tier_KING: "市场王者",
    ranking_tier_SHADOW_MASTER: "SHADOW MASTER",
    ranking_tier_LIGHTNING: "闪电交易者",
    ranking_tier_PRECISION: "精准猎手",
    ranking_tier_FIRE: "火热状态",
    ranking_tier_DIAMOND: "钻石之手",
    ranking_tier_STRUCTURE: "结构解读者",
    ranking_tier_LIQUIDITY: "流动性潜水员",
    ranking_tier_RISING: "崛起的RE₿EL",
    ranking_months: {
      "10": "十月",
      "11": "十一月",
      "12": "十二月",
      "01": "一月",
      "02": "二月",
      "03": "三月",
      "04": "四月",
      "05": "五月",
      "06": "六月",
      "07": "七月",
      "08": "八月",
      "09": "九月",
    },
    rw_top_traders: "⚡ 本月顶级交易员",
    rw_calculating: "计算中…",
    rw_empty: "本月还没有已评估的分析。",
    rw_see_full: "查看完整排名 →",
    rw_days_unit: "天",
    rw_until_month_end: "距月底",
    rw_prize: "奖励",
    rw_prize_value: "Shadow Mkt 50%",
    ac_zoom_image: "放大",
    ac_zoom_aria: "放大图片",
    ac_ago_prefix: "",
    ac_ago_now: "刚刚",
    ac_eval_pending: "等待24小时评估",
    ac_delete: "删除",
    ac_delete_admin: "删除（管理员）",
    ac_admin_label: "管理员",
    acm_header: "评论",
    acm_loading: "加载中…",
    acm_empty: "成为第一个评论的人。",
    acm_admin_badge: "Shadow管理员",
    acm_delete_aria: "删除评论",
    acm_placeholder: "写下评论…",
    acm_submit: "评论",
    acm_max_chars: "最多280个字符",
    acm_error_generic: "评论出错",
    acm_login: "登录",
    acm_login_suffix: " 以评论 · ",
    acm_register: "免费创建账户",
    acm_ago_prefix: "",
    acm_ago_now: "刚刚",
    pam_button: "发布分析",
    pam_field_title: "标题",
    pam_field_title_ph: "例：BTC 4H看涨结构 — 可能的入场点",
    pam_field_analysis: "分析",
    pam_field_analysis_ph: "详细描述你的分析：市场结构、关键点位、订单块、流动性区域、宏观倾向、设置失效条件、交易管理…",
    pam_field_ticker_ph: "BTC/USDT",
    pam_field_direction: "方向",
    pam_submit: "发布分析 →",
    pam_processing_video: "处理视频中…",
    pam_publishing: "发布中…",
    pam_err_video_type: "视频：MP4、MOV或WebM。",
    pam_err_video_size: "视频最大100MB。",
    pam_err_file_type: "仅支持JPG、PNG、WebP — 或视频MP4/MOV/WebM。",
    pam_err_image_size: "图片最大5MB。",
    pam_err_select_file: "选择一张图片或视频。",
    pam_err_title_min: "标题最少3个字符。",
    pam_err_title_max: "标题最多80个字符。",
    pam_err_desc_min: "描述最少50个字符。",
    pam_err_desc_max: "描述最多5000个字符。",
    pam_cancel: "取消",
    pam_published: "已发布",
    pam_video_hint: "⚡ 视频将自动处理并裁剪至90秒。",
    pam_label_ticker: "代码",
    pam_label_timeframe: "时间周期",
    pam_chars_5000: "字符",
    pam_pro_gate_title: "发布仅限PRO",
    pam_pro_gate_body: "激活RE₿EL PRO以与Shadow Network分享你的分析。所有人可查看和点赞，但只有PRO可发布。",
    pam_pro_gate_cta: "激活PRO · €39.90",
    pam_eyebrow: "◈ Shadow Network · 发布",
    pam_modal_title: "分享你的分析",
    pam_modal_sub: "仅PRO交易员可发布。所有人可查看。",
    pam_dropzone_title: "将分析拖到此处",
    pam_dropzone_sub: "或点击 · 图片5MB · 视频100MB · 最长90秒",
    pam_video_badge: "▶ 视频 · 最长90秒",
    sp_btn: "分享",
    sp_aria: "分享分析",
    sp_err_image: "无法生成图片。请重试。",
  },
  de: {
    nav_btn: "Shadow Network",
    eyebrow: "Vertraulich · Operator-Zugang",
    hero_title: "SHADOW NETWORK™",
    hero_sub: "Institutionelles Rekrutierungsnetzwerk. Du lädst keine Freunde ein. Du rekrutierst Trader.",
    profile_title: "Deine operative Identität",
    codename_label: "Codename",
    invite_label: "Einladungscode",
    link_label: "Rekrutierungslink",
    copy: "Kopieren",
    copied: "Kopiert",
    share: "Teilen",
    share_via_x: "X / Twitter",
    share_via_telegram: "Telegram",
    share_via_whatsapp: "WhatsApp",
    share_via_facebook: "Facebook",
    share_via_instagram: "Instagram",
    ig_modal_title: "Auf Instagram teilen",
    ig_modal_sub: "Lade das Bild herunter und füge den Text in deinen Post oder deine Story ein.",
    ig_modal_copy: "Text kopieren",
    ig_modal_copied: "Text kopiert",
    ig_modal_download: "Bild herunterladen",
    ig_modal_close: "Schließen",
    stats_xp: "RE₿EL XP™",
    stats_reputation: "Reputation",
    stats_rank: "Rang",
    stats_active: "Aktive Trader",
    stats_converted: "Konversionen",
    stats_total: "Rekrutiert",
    rank_progress: "Rang-Fortschritt",
    next_rank: "Nächster Rang",
    xp_to_next: "Verbleibende XP",
    max_rank: "Maximaler Rang erreicht",
    unlocks_title: "Operatives Freischaltungssystem",
    unlocks_sub: "Aktive Trader rekrutieren schaltet vertrauliche Zugangsebenen frei.",
    locked: "Gesperrt",
    unlocked: "Freigeschaltet",
    invites_needed: "verbleibende aktive Trader",
    network_title: "Dein rekrutiertes Netzwerk",
    network_empty: "Du hast noch keine Trader rekrutiert. Teile deinen Link, um zu starten.",
    status_pending: "Ausstehend",
    status_active: "Aktiv",
    status_converted: "Konvertiert",
    joined_at: "Rekrutiert",
    leaderboard_title: "Globale Trader-Rangliste",
    leaderboard_sub: "Top 25 nach Reputationsscore. Echtzeit-Update.",
    th_rank: "#",
    th_codename: "Trader",
    th_xp: "XP",
    th_rep: "Reputation",
    th_recruits: "Rekrutiert",
    activity_xp: {
      lesson_complete: "Lektion abschließen",
      mentor_message: "Nachricht an KI-Mentor",
      simulator_end: "Simulation abschließen",
      referral_active: "Aktiver Trader rekrutiert",
      referral_converted: "PRO-Konversion",
    },
    cta_share_label: "Operatives Netzwerk verbreiten",
    cta_share_default: "Ich bin gerade dem SHADOW NETWORK™ von RE₿EL BTC beigetreten. Echte Trader. Vertraulicher Zugang.",
    badge_pro: "PRO",
    badge_ambassador: "AMBASSADOR",
    badge_elite: "ELITE",
    rank_RECRUIT: "REKRUT",
    rank_OPERATOR: "OPERATOR",
    rank_SHADOW_ANALYST: "SCHATTEN-ANALYST",
    rank_LIQUIDITY_HUNTER: "LIQUIDITÄTSJÄGER",
    rank_MARKET_COMMANDER: "MARKT-KOMMANDANT",
    rank_REBEL_ELITE: "RE₿EL ELITE",
    tab_overview: "Übersicht",
    tab_network: "Netzwerk",
    tab_leaderboard: "Leaderboard",
    radar_label: "Aktiver operativer Scan",
    classified_seal: "VERTRAULICH · OPS-STUFE",
    join_alert_title: "Nicht autorisierter Operator-Zugang",
    join_alert_msg: "Erstelle dein Konto, um deinen Codename zu aktivieren und ins Netzwerk einzutreten.",
    join_cta: "Zugang anfordern",
    share_kit: "Share-Kit",
    share_all_networks: "ALLE NETZWERKE",
    share_modal_title: "Beitrag teilen",
    share_modal_sub: "Lade das Bild herunter, kopiere den Text und poste ihn in deinem bevorzugten Netzwerk. Dein persönlicher Link behält das Referral-Tracking bei.",
    share_open_in: "Öffnen in",
    share_caption_preview: "Caption-Vorschau",
    share_instagram_manual: "Instagram · manuell",
    share_instagram_title: "Instagram erlaubt kein Teilen per URL — nutze Herunterladen + Kopieren",
    share_native_title: "REBEL · Die Rebellion des digitalen Geldes",
    feed_eyebrow: "◈ Operation · Briefings",
    feed_title: "Netzwerk-Analysen",
    feed_sub: "Setups geteilt von PRO-Operatoren. Reagiere, kommentiere und lerne von der Hierarchie.",
    feed_filter_tf_ph: "Timeframe",
    feed_filter_dir_ph: "Richtung",
    feed_clear: "Löschen",
    feed_loading: "Lade Analysen…",
    feed_empty_title: "Es gibt noch keine veröffentlichten Analysen mit diesen Filtern.",
    feed_empty_sub: "Sei der Erste, der teilt — klicke \"Analyse veröffentlichen\".",
    feed_loadmore: "Mehr laden",
    feed_loadmore_loading: "Lädt…",
    chat_title: "Shadow Chat",
    chat_pro_writes_all_read: "Nur PRO schreibt · Alle können lesen",
    chat_loading: "Lädt…",
    chat_first_msg: "Sei der Erste, der schreibt 👋",
    chat_admin_label: "Admin",
    chat_input_ph: "Schreibe deine Analyse…",
    chat_send: "Senden",
    chat_delete: "Löschen",
    chat_confirm_delete: "Diese Nachricht löschen?",
    chat_pro_only_writes: "Nur PRO schreibt im Chat",
    chat_pro_cta: "PRO aktivieren →",
    chat_login_required: "Melde dich an, um teilzunehmen",
    chat_login_cta: "Anmelden →",
    chat_enter_send_shift_newline: "Enter sendet · Shift+Enter neue Zeile",
    chat_relative_now: "jetzt",
    ranking_back_feed: "Zurück zum Feed",
    ranking_subtitle: "Die KI bewertet jede Analyse und aktualisiert das Ranking alle 24h",
    ranking_updated_today: "Heute aktualisiert",
    ranking_loading: "Lade Ranking…",
    ranking_load_failed: "Ranking konnte nicht geladen werden",
    ranking_stat_analyses: "Analysen",
    ranking_stat_traders: "Trader",
    ranking_stat_score_avg: "Durchschnittsscore",
    ranking_stat_days_left: "verbleibende Tage",
    ranking_winner_of: "Champion von",
    ranking_winner_badge: "Gewinner",
    ranking_winner_score: "Score:",
    ranking_winner_accuracy: "Genauigkeit:",
    ranking_winner_analyses: "Analysen:",
    ranking_winner_prize: "Preis vergeben: 50% auf Shadow Market™",
    ranking_empty: "Es gibt noch kein Ranking diesen Monat. Veröffentliche deine Analysen und komm morgen zurück.",
    ranking_how_toggle: "Wie funktioniert das Ranking?",
    ranking_how_intro_pre: "Die KI bewertet jede Analyse",
    ranking_how_intro_strong: "24h nach",
    ranking_how_intro_post: "ihrer Veröffentlichung und vergleicht die vorhergesagte Richtung mit der tatsächlichen Bewegung:",
    ranking_how_b1_strong: "Korrekte Richtung",
    ranking_how_b1_rest: "(LONG/SHORT/NEUTRAL): 50 Punkte",
    ranking_how_b2_strong: "Analyse-Genauigkeit",
    ranking_how_b2_rest: "(erwähnte Levels): 30 Punkte",
    ranking_how_b3_strong: "Korrekter Timeframe",
    ranking_how_b3_rest: ": 20 Punkte",
    ranking_how_b4_strong: "Community-Bonus",
    ranking_how_b4_rest: "(Reaktionen + Kommentare): bis zu +10 Pkt",
    ranking_how_footer_pre: "Mindestanforderung für den Preis:",
    ranking_how_footer_min: "3 bewertete Analysen",
    ranking_how_footer_mid: "in diesem Monat. Der monatliche Gewinner erhält",
    ranking_how_footer_prize: "50% Rabatt auf Shadow Market™.",
    ranking_disclaimer: "Das Ranking dient Bildungs- und Unterhaltungszwecken. Die Analysen stellen keine Finanzberatung dar.",
    ranking_admin: "Admin",
    ranking_view_analyses: "Analysen ansehen →",
    ranking_row_analyses: "Analysen",
    ranking_row_evaluated: "bewertet",
    ranking_row_correct: "korrekt",
    ranking_tier_KING: "MARKT-KÖNIG/-KÖNIGIN",
    ranking_tier_SHADOW_MASTER: "SHADOW MASTER",
    ranking_tier_LIGHTNING: "LIGHTNING TRADER",
    ranking_tier_PRECISION: "PRECISION HUNTER",
    ranking_tier_FIRE: "ON FIRE",
    ranking_tier_DIAMOND: "DIAMOND HANDS",
    ranking_tier_STRUCTURE: "STRUCTURE READER",
    ranking_tier_LIQUIDITY: "LIQUIDITY DIVER",
    ranking_tier_RISING: "RISING REBEL",
    ranking_months: {
      "10": "OKTOBER",
      "11": "NOVEMBER",
      "12": "DEZEMBER",
      "01": "JANUAR",
      "02": "FEBRUAR",
      "03": "MÄRZ",
      "04": "APRIL",
      "05": "MAI",
      "06": "JUNI",
      "07": "JULI",
      "08": "AUGUST",
      "09": "SEPTEMBER",
    },
    rw_top_traders: "⚡ Top-Trader des Monats",
    rw_calculating: "Berechne…",
    rw_empty: "Es gibt noch keine bewerteten Analysen diesen Monat.",
    rw_see_full: "Vollständiges Ranking ansehen →",
    rw_days_unit: "Tage",
    rw_until_month_end: "bis Monatsende",
    rw_prize: "Preis",
    rw_prize_value: "50% Shadow Mkt",
    ac_zoom_image: "Vergrößern",
    ac_zoom_aria: "Bild vergrößern",
    ac_ago_prefix: "vor",
    ac_ago_now: "jetzt",
    ac_eval_pending: "Warte 24h auf Bewertung",
    ac_delete: "Löschen",
    ac_delete_admin: "Löschen (Admin)",
    ac_admin_label: "Admin",
    acm_header: "Kommentare",
    acm_loading: "Lädt…",
    acm_empty: "Sei der Erste, der kommentiert.",
    acm_admin_badge: "Shadow Admin",
    acm_delete_aria: "Kommentar löschen",
    acm_placeholder: "Schreibe einen Kommentar…",
    acm_submit: "Kommentieren",
    acm_max_chars: "Maximal 280 Zeichen",
    acm_error_generic: "Fehler beim Kommentieren",
    acm_login: "Anmelden",
    acm_login_suffix: " um zu kommentieren · ",
    acm_register: "Kostenloses Konto erstellen",
    acm_ago_prefix: "vor",
    acm_ago_now: "jetzt",
    pam_button: "Analyse veröffentlichen",
    pam_field_title: "Titel",
    pam_field_title_ph: "Z.B.: BTC bullische Struktur auf 4H — Möglicher Einstieg",
    pam_field_analysis: "Analyse",
    pam_field_analysis_ph: "Beschreibe deine Analyse so detailliert wie nötig: Marktstruktur, Schlüssel-Levels, Order-Blocks, Liquiditätszonen, Makro-Bias, Setup-Invalidierung, Trade-Management...",
    pam_field_ticker_ph: "BTC/USDT",
    pam_field_direction: "Richtung",
    pam_submit: "Analyse veröffentlichen →",
    pam_processing_video: "Video wird verarbeitet…",
    pam_publishing: "Veröffentliche…",
    pam_err_video_type: "Video: MP4, MOV oder WebM.",
    pam_err_video_size: "Video maximal 100MB.",
    pam_err_file_type: "Nur JPG, PNG, WebP — oder Video MP4/MOV/WebM.",
    pam_err_image_size: "Bild maximal 5MB.",
    pam_err_select_file: "Wähle ein Bild oder Video aus.",
    pam_err_title_min: "Titel mindestens 3 Zeichen.",
    pam_err_title_max: "Titel maximal 80 Zeichen.",
    pam_err_desc_min: "Beschreibung mindestens 50 Zeichen.",
    pam_err_desc_max: "Beschreibung maximal 5000 Zeichen.",
    pam_cancel: "Abbrechen",
    pam_published: "Veröffentlicht",
    pam_video_hint: "⚡ Das Video wird automatisch verarbeitet und auf 90s gekürzt.",
    pam_label_ticker: "Ticker",
    pam_label_timeframe: "Timeframe",
    pam_chars_5000: "Zeichen",
    pam_pro_gate_title: "Veröffentlichen ist für PRO",
    pam_pro_gate_body: "Aktiviere RE₿EL PRO, um deine Analysen mit dem Shadow Network zu teilen. Alle können sehen und reagieren, aber nur PRO veröffentlicht.",
    pam_pro_gate_cta: "PRO aktivieren · €39.90",
    pam_eyebrow: "◈ Shadow Network · Veröffentlichung",
    pam_modal_title: "Teile deine Analyse",
    pam_modal_sub: "Nur PRO-Operatoren können veröffentlichen. Alle können sehen.",
    pam_dropzone_title: "Ziehe deine Analyse hierher",
    pam_dropzone_sub: "oder klicke · Bild 5MB · Video 100MB · max 90s",
    pam_video_badge: "▶ VIDEO · MAX 90s",
    sp_btn: "Teilen",
    sp_aria: "Analyse teilen",
    sp_err_image: "Bild konnte nicht erstellt werden. Versuche es erneut.",
  },
};

export const getShadowI18n = (lang) => SHADOW_I18N[lang] || SHADOW_I18N.es;
